"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Attachment = function Attachment(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/file/attachment-attachment" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "fill-1-attachment" + unique,
    xlinkHref: "#path-1-attachment" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-attachment" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.0003,5.9998 C3.6863,5.9998 1.0003,8.6868 1.0003,11.9998 C1.0003,15.3128 3.6863,17.9998 7.0003,17.9998 L17.5003,17.9998 C17.7753,17.9998 18.0003,17.7758 18.0003,17.4998 L18.0003,16.4998 C18.0003,16.2238 17.7753,15.9998 17.5003,15.9998 L7.0003,15.9998 C4.7903,15.9998 3.0003,14.2088 3.0003,11.9998 C3.0003,9.7908 4.7903,7.9998 7.0003,7.9998 L11.4633,7.9998 L14.7603,7.9998 L18.5003,7.9998 C19.8803,7.9998 21.0003,9.1188 21.0003,10.4998 C21.0003,11.8808 19.8803,12.9998 18.5003,12.9998 L14.7603,12.9998 L12.9103,12.9998 L10.8583,12.9998 L8.0003,12.9998 C7.4473,12.9998 7.0003,12.5528 7.0003,11.9998 C7.0003,11.4478 7.4473,10.9998 8.0003,10.9998 L10.8163,10.9998 L12.9053,10.9998 L14.0503,10.9998 L16.0503,10.9998 L17.5003,10.9998 C17.7764424,10.9998 18.0003,10.7759424 18.0003,10.4998 L18.0003,9.4998 C18.0003,9.22365763 17.7764424,8.9998 17.5003,8.9998 L16.5113,8.9998 L14.2753,8.9998 L12.1903,8.9998 L9.6203,8.9998 L8.0003,8.9998 C6.3433,8.9998 5.0003,10.3438 5.0003,11.9998 C5.0003,13.6568 6.3433,14.9998 8.0003,14.9998 L9.6163,14.9998 L12.1883,14.9998 L18.5003,14.9998 C20.9853,14.9998 23.0003,12.9848 23.0003,10.4998 C23.0003,8.0148 20.9853,5.9998 18.5003,5.9998 L7.0003,5.9998 Z",
    fill: "inherit",
    id: "path-1-attachment" + unique
  }))));
};

Attachment.propTypes = propTypes;
var _default = Attachment;
exports["default"] = _default;